import { atom, useAtom } from "jotai";
import { useState } from "react";
import axios from "axios";
import useGraalApi from "../hooks/useGraalApi/useGraalApi";
import useStore from "../context/useStore";

const graalApiAuthAtom = atom(null);

//axios instance using a bearer token
export const graalApiAxiosInstance = axios.create({
  withCredentials: true,
});

const useApiAuthMiddleware = () => {
  const [state] = useStore();
  const [apiAuthError, setApiAuthError] = useState("");
  const [graalApiAuth, setGraalApiAuth] = useAtom(graalApiAuthAtom);
  const { graalApiActions } = useGraalApi();
  const user = state.auth.user;

  graalApiAxiosInstance.interceptors.request.use((config) => {
    if (user?.id) {
      const userInfo = {
        id: user.id,
        name: user.firstname + " " + user.lastname,
        email: user.email,
      };

      config.headers["X-Perceval-User"] = btoa(
        encodeURIComponent(JSON.stringify(userInfo)).replace(
          /%([0-9A-F]{2})/g,
          (match, p1) => String.fromCharCode(parseInt(p1, 16))
        )
      );
    }
    return config;
  });

  const apiAuthActions = {
    authenticateWithTarificatorApi: async () => {
      const response = await graalApiActions.getAuthToken();
      setGraalApiAuth(response.data);
      if (response.data.token) {
        graalApiAxiosInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${response.data.token}`;
        //set the axios instance to use the token
        graalApiAxiosInstance.defaults.withCredentials = true;
        return true;
      } else {
        setApiAuthError("Jeton de connexion au tarificateur invalide");
        return false;
      }
    },
  };
  return {
    apiAuthError,
    graalApiAuth,
    apiAuthActions,
  };
};

export default useApiAuthMiddleware;
